var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}check`,"viewBox":"0 0 16 16"}},[_c('circle',{staticClass:"base",attrs:{"cx":"8","cy":"8","r":"8"}}),_c('path',{staticClass:"sign",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.7072 7.20718L7.50008 11.4143L4.29297 8.20718L5.70718 6.79297L7.50008 8.58586L10.293 5.79297L11.7072 7.20718Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }